import { nonFalsey } from '../nonFalsey';

interface Edge<T> {
  node?: T | null | undefined;
}

interface Connection<T> {
  edges: Array<Edge<T> | null | undefined> | null | undefined;
}

export const extractConnectionProps = <T>(
  connection: Connection<T> | null | undefined,
) => {
  const { edges } = connection || {};

  const nodes = edges?.map((edge) => edge?.node).filter(nonFalsey) || [];

  return nodes;
};

interface PageInfo {
  hasNextPage?: boolean;
  hasPreviousPage?: boolean;
  endCursor?: string | null;
  startCursor?: string | null;
}

interface PaginatedConnection<T> {
  totalCount?: number;
  pageInfo?: PageInfo;
  edges: Array<Edge<T> | null | undefined> | null | undefined;
}

export interface PaginatedResult<T> {
  totalCount: number;
  nodes: T[];
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  endCursor: string | null;
  startCursor: string | null;
}

export const extractPaginationProps = <T>(
  connection: PaginatedConnection<T> | null | undefined,
): PaginatedResult<T> => {
  const { pageInfo, edges } = connection || {};

  const totalCount = connection?.totalCount || 0;

  const nodes = edges?.map((edge) => edge?.node).filter(nonFalsey) || [];

  const hasNextPage = pageInfo?.hasNextPage || false;
  const hasPreviousPage = pageInfo?.hasPreviousPage || false;
  const endCursor = pageInfo?.endCursor || null;
  const startCursor = pageInfo?.startCursor || null;

  return {
    totalCount,
    nodes,
    hasNextPage,
    hasPreviousPage,
    endCursor,
    startCursor,
  };
};
